import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../components/home/home.vue'
import Index from '../components/home/index.vue'
// import Index from '../components/index.vue'
// 立体教材
import Teachingmat from '../components/teachingmaterial/teachingmat.vue'
import Matdetails from '../components/teachingmaterial/matdetails.vue'
import Chaptertest from '../components/teachingmaterial/chaptertest.vue'

import trainDetail from '../components/teachingmaterial/trainDetail.vue'

import BookTrain from '../components/teachingmaterial/bookTrain.vue'
// 选书库
import BookList from '../components/chooseBooks/bookList.vue';// 我的选书
// 个人中心
import Center from '../components/center/center.vue'
import Mycourse from '../components/center/mycourse.vue'
import Self from '../components/center/self.vue'
import Collection from '../components/center/collection.vue'
import Publish from '../components/center/publish.vue'
import Liuyan from '../components/center/liuyan.vue'
import apply from '../components/center/apply.vue'
import listDetail from '../components/center/list-detail.vue';
import bookDetail from '../components/center/bookDetail.vue'
import publishbookadd from '../components/center/publishbookadd.vue'
import Password from '../components/center/password.vue'

// 书目下载
import Catalog from '../components/catalog/catalog.vue'
// 教师认证
import Authentication from '../components/authentication/authentication.vue'
import onLine from '../components/onLine/onLine.vue'
import newslist from '../components/newslist/newslist.vue'
import newsDetail from '../components/newslist/newsDetail.vue'
import press from '../components/press/index.vue'
Vue.use(VueRouter)

const routes = [{
    path: '/',
    name: 'Home',
    component: Home,
    redirect: '/teachingmat',
    children: [
        // { path: '/index', component: Index },
        { path: '/traindetail', component: trainDetail },
        { path: '/teachingmat', component: Teachingmat },
        { path: '/booktrain', component: BookTrain },
        { path: '/teachingmat/Matdetails', component: Matdetails },
        { path: '/teachingmat/Matdetails/chaptertest', component: Chaptertest },
        { path: '/catalog', component: Catalog },
        { path: '/authentication', component: Authentication },
        { path: '/myBookList', component: BookList },
        {
            path: '/center', component: Center,
            redirect: '/center/self',
            children: [
                { path: '/center/mycourse', component: Mycourse },
                { path: '/center/self', component: Self },
                { path: '/center/collection', component: Collection },
                { path: '/center/listDetail', component: listDetail },
                { path: '/center/bookDetail', component: bookDetail },
                { path: '/center/publish', component: Publish },
                { path: '/center/liuyan', component: Liuyan },
                { path: '/center/apply', component: apply },
                { path: '/center/publishbookadd', component: publishbookadd },
                { path: '/center/password', component: Password },
            ]
        },
        { path: '/Index', component: Index },
        { path: '/onLine', component: onLine },
        { path: '/onLine/Matdetails', component: Matdetails },
        { path: '/newslist', component: newslist },
        { path: '/newsDetail', component: newsDetail },
        { path: '/press', component: press },

    ]
},
{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
        import( /* webpackChunkName: "about" */ '../views/About.vue')
}
]

const router = new VueRouter({
    routes
})
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
export default router
